// extracted by mini-css-extract-plugin
export default {"component":"ContentPage_component__GIbe1","noDoc":"ContentPage_noDoc__MqXaW"};